export default __webpack_public_path__ + "f21e5a044e2f007d94e415f25d195e74.png";